import type { ComponentDocMap } from './types'

/**
 * Prop documentation for the `review_forecasts` anchor component.
 * Keep in sync with ReviewForecastsProps in src/ui/uiConfig/anchorComponents/ReviewForecasts/ReviewForecasts.types.ts
 */
export const reviewForecastsPropDocs: ComponentDocMap = {
  tabs: {
    description: 'Forecast review tabs.',
    type: 'ReviewForecastsTab[]',
  },
  'tabs[].title': { description: 'Tab title.', type: 'string' },
  'tabs[].cards': { description: 'Cards displayed in tab.', type: 'ReviewForecastsCard[]' },
  'tabs[].cards[].title': { description: 'Card title.', type: 'string' },
  'tabs[].cards[].default_collapsed': { description: 'Initial collapsed state.', type: 'boolean' },
  'tabs[].cards[].children_list': {
    description: 'Child config references in card.',
    type: 'ReviewForecastsChild[]',
  },
  'tabs[].cards[].children_list[].ui_config_id': { description: 'Child ui_config id.', type: 'number' },
  'tabs[].cards[].children_list[].override_alias': {
    description: 'Alias override for this child.',
    type: 'UiConfigAliases',
  },
}
